import script from "./BaseLevel.vue?vue&type=script&lang=js"
export * from "./BaseLevel.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__